export const SIGNUP_PARAMS = {
  GCP_MARKETPLACE_TOKEN: "x-gcp-marketplace-token",
  ENTITLEMENT_ID: "entitlement-id",
  MP: "mp",
  TOKEN: "token"
} as const

export const ALLOWED_SIGNUP_PARAMS = Object.values(SIGNUP_PARAMS)
